import { Profile, ProfilePreview } from "PFCore/types";
import { SyntheticEvent } from "react";

export const showChatProfile = (
  handleMinimize: (event: SyntheticEvent) => void,
  e: SyntheticEvent,
  profile: Profile,
  showProfile: (params: Pick<ProfilePreview, "id" | "profile" | "showBookingButtons">) => void
) => {
  handleMinimize?.(e);
  showProfile({ id: profile.id, profile });
};
